@if (slotName$ | async; as slotName) {
<div [attr.id]="slotName" #host></div>
}
